// UnitDefaultHandlersTree
// ***********************************************************************************************************************
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HomeIcon from "@mui/icons-material/Home";
import { Box, Grid, ListItemButton, Typography } from "@mui/material";
import * as React from "react";
import { ListStateIconTool } from "source/components/framework/List/ListStateIconTool";
import { DefaultHandlerType } from "../../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/enums";
import { IUnitDefaultHandlersNode } from "../../../../models/unit/unitDefaultHandlersNode";
import { EllipsisTypography } from "../../../framework/Typography/EllipsisTypography";

export interface IUnitDefaultHandlersTreeProp {
    classes?: string;
    unitNode: IUnitDefaultHandlersNode;
    selectedId?: string;
    level?: number;
    isFirstNode: boolean;
    showHandlerTypes?: boolean;
    height?: string | number;
    onClick: (id: string) => void;
    onOpen: (id: string) => void;
}

export class UnitDefaultHandlersTree extends React.Component<IUnitDefaultHandlersTreeProp, {}> {
    static defaultProps = {
        height: "calc(100vh - 420px)"
    };

    handleUnitNodeClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        props.onClick(props.unitNode.id);
    };
    
    handleUnitNodeDoubleClick = (e) => {
        const props = this.props;
        if (e) {
            e.stopPropagation();
        }
        props.onOpen(props.unitNode.id);
    };

    render() {
        const props = this.props;
        const unitNode = props.unitNode;
        if (!unitNode) return null;
        const hasChildren = unitNode.children.length > 0;
        const hasVisibleChildren = hasChildren;
        const isRoot = unitNode.getIsRoot();
        let selectedId = props.selectedId;
        if (!props.selectedId && isRoot) {
            selectedId = unitNode.id;
        }
        const defaultHandlersText = unitNode.getDefaultUsersText(props.showHandlerTypes ? DefaultHandlerType.Handler : null);
        const defaultNotifiedText = props.showHandlerTypes ? unitNode.getDefaultUsersText(DefaultHandlerType.Notfied) : "";
        const hasExplicitUsers = unitNode.hasExplicitUsers();
        return (
            <Box sx={{
                maxHeight: props.height,
                overflowX: "hidden",
                overflowY: "auto",
            }}>
                <ListItemButton
                    selected={selectedId === props.unitNode.id}
                    className={(!hasChildren ? " noChilds" : "") + (isRoot ? " root" : "") + (unitNode.partnerCompanyIds.length > 0 ? " hasPartners" : "")}
                    onClick={this.handleUnitNodeClick} onDoubleClick={this.handleUnitNodeDoubleClick}
                >
                    <Grid container alignItems="center">
                        <Grid item sm={5} sx={{ paddingLeft: (10 * props.level).toString(10) + "px" }}>
                            <Box display="flex" alignItems="center">
                                {(!isRoot && !props.isFirstNode) &&
                                <>
                                    {hasVisibleChildren
                                        ? (
                                            <ExpandMoreIcon fontSize="small" />
                                        )
                                        : (
                                            <Box sx={{ width: "20px" }} />
                                        )}
                                </>
                                }
                                <HomeIcon sx={{ marginRight: ".5rem" }} />
                                <Typography fontWeight={selectedId === props.unitNode.id ? 600 : 400}>
                                    {unitNode.name}
                                </Typography>
                                {unitNode.partnerCompanyIds.length ? <Typography color="error" sx={{ marginLeft: ".5rem" }}>*</Typography> : null}
                            </Box>
                        </Grid>
                        <Grid item sm={7}>
                            <Grid container>
                                <Grid item sm={props.showHandlerTypes ? 6 : 12} title={defaultHandlersText} onClick={() => this.handleUnitNodeDoubleClick(null)}>
                                    <Box display="flex" alignItems="center">
                                        {hasExplicitUsers &&
                                            <ListStateIconTool noMargin />
                                        }
                                        {defaultHandlersText ? <EllipsisTypography fontWeight={selectedId === props.unitNode.id ? 600 : 400} sx={{ marginLeft: hasExplicitUsers ? ".5rem" : 0 }}>{defaultHandlersText}</EllipsisTypography> : "&nbsp;"}
                                    </Box>
                                </Grid>
                                {!!props.showHandlerTypes &&
                                    <Grid item sm={6} title={defaultNotifiedText} onClick={() => this.handleUnitNodeDoubleClick(null)}>
                                        <Box display="flex" alignItems="center">
                                            {hasExplicitUsers &&
                                                <ListStateIconTool noMargin />
                                            }
                                            {defaultNotifiedText ? <EllipsisTypography fontWeight={selectedId === props.unitNode.id ? 600 : 400} sx={{ marginLeft: hasExplicitUsers ? ".5rem" : 0 }}>{defaultNotifiedText}</EllipsisTypography> : "&nbsp;"}
                                        </Box>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </ListItemButton>
                {unitNode.children.map((childUnitNode) =>
                    <UnitDefaultHandlersTree
                        key={childUnitNode.id}
                        unitNode={childUnitNode}
                        selectedId={selectedId}
                        isFirstNode={false}
                        level={props.level ? (props.level + 1) : 1}
                        showHandlerTypes={props.showHandlerTypes}
                        onClick={props.onClick}
                        onOpen={props.onOpen}
                    />
                )}
            </Box>
        );
    }
}